import * as Sentry from '@sentry/browser';
import {wasmIntegration} from '@sentry/wasm';

import {loginStateChangeEmitter} from './logics/auth';
import {
  ETextParamType_GetHeliodorSDKMajorVersion,
  ETextParamType_GetHeliodorSDKMinorVersion
} from './logics/const';
import {hel_setText} from './logics/moduleCaller';
import {updateSentryUserCodeFromChannelSession} from './logics/monitor';

const environment = globalThis.heliport.v3.utils.isProduction() ? 'production' : 'staging';

Sentry.init({
  enabled:
    environment === 'production' || new URLSearchParams(location.search).has('remote_monitor'),
  dsn: 'https://1bb50c685023da49441e1d0cb0f191ca@o4504688498704384.ingest.us.sentry.io/4508612432166912',
  integrations: [wasmIntegration(), Sentry.browserProfilingIntegration()],
  environment
});

loginStateChangeEmitter.addEventListener('change', updateSentryUserCodeFromChannelSession);

/**
 * {@link hel_setText} → {@link HeliModule.ccall} → `wasmExports`
 * のように参照されている `wasmExports` が宣言されるまで待機する。
 */
const waitForWASMExportsExportsDeclaration = () => {
  if (typeof globalThis.wasmExports === 'undefined') {
    window.setTimeout(waitForWASMExportsExportsDeclaration, 100);
    return;
  }

  Sentry.setTag(
    'heliodor_lib_version',
    hel_setText(ETextParamType_GetHeliodorSDKMajorVersion, '') +
      '.' +
      hel_setText(ETextParamType_GetHeliodorSDKMinorVersion, '')
  );
};
waitForWASMExportsExportsDeclaration();
